export default __webpack_public_path__ + "static/media/purchased-icon.dc90db4b.svg";